// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { getProp } from "@insite/mobius/utilities";
import { compactHeaderStyles } from "@sc/Overrides/Pages/CompactHeader";
import { color, layoutContainer, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

compactHeaderStyles.page = {
    padding: 0, // * Padding doesn't work with fullWidth because of logic on Line 64 if Page component
    fullWidth: [true, true, true, true, true, true], // make the header full width and control the margins with container css
    css: css`
        top: 0;
        left: 0;
        z-index: ${getProp("theme.zIndex.compactHeader")};
        box-shadow: 0 1px 0 0 ${color("common.border")};
        opacity: 0;
        transform: translateY(-100%) translateX(0);
        padding: ${props => props.theme.header.padding};
        background-color: ${color("common.white")};
        &&&& {
            position: fixed;
        }
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

compactHeaderStyles.logoWrapper = {
    css: css`
        display: flex;
        align-items: center;
        gap: 32px;
    `,
};

compactHeaderStyles.navigationWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        position: absolute;
        background: ${color("common.white")};
        width: 100%;
        top: -200px;
        box-shadow: 0 1px 0 0 ${color("common.border")};
        padding-bottom: 8px;
        ${({ showMainNavigation }: any) =>
            showMainNavigation
                ? css`
                      top: 100%;
                      transform: translateY(-1px); // To replace box-shadow
                  `
                : ""}
        > div {
            ${layoutContainer}
        }
        &&&& > main {
            margin-bottom: 0;
        }
    `,
};

compactHeaderStyles.itemsWrapper = {
    css: css`
        flex-grow: 1;
    `,
};
compactHeaderStyles.rightSectionWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 36px;
        margin-left: auto;
        padding-right: 8px;
    `,
};
compactHeaderStyles.mainNavigationPageWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        &&&& {
            padding-top: 0;
            padding-bottom: 0;
        }
        &&&& .container {
            padding: 0;
        }
    `,
};
compactHeaderStyles.mainNavigationWrapper = {
    css: css`
        width: 100%;
        &&&& {
            padding: 0;
        }
    `,
};
compactHeaderStyles.closeMenuClickable = {
    css: css`
        width: 30px;
        height: 30px;
        justify-content: center;
        &:hover {
            ${IconWrapper} {
                color: ${color("common.ui8")};
            }
        }
    `,
};

compactHeaderStyles.searchWrapper = {
    css: css`
        align-self: center;
        flex-grow: 1;
        max-width: 832px;
        ${xScreen("lte", "lg")} {
            max-width: 656px;
        }
    `,
};
